import React from "react";

// The master JSON dictionary linking 4-character codes to their full kit names
const BUBBLE_KIT_MAP = {
  HUM1: "human",
  HOM2: "home",
  GEO3: "geo",
  FIR4: "fireworks",
  P3D5: "portrait3d",
  TRP6: "portraittrap",
  AFR7: "portraitafrica",
  AFZ8: "portraitafricazone",
  AFW9: "africawesttrap",
  AFS0: "africasouthtrap",
  LTK1: "letterkit",
  LHK2: "letterhebrewkit",
  LHT3: "letterhebrewtextkit",
  LGT4: "lettergreektextkit",
  WDK1: "wordkindkit",
  WDH2: "wordhidekit",
  WDA3: "wordanimalkit",
  WKC4: "wordkindcontourkit",
  WNC5: "wordnocontourkit",
  WAC6: "wordanimalcontourkit",
  CTK7: "customtextcontourkit",
  ROD1: "road",
  CAR1: "car",
  CUB1: "carcube",
  CBT2: "carcubetilt",
  CBS3: "carcubesegment",
  CBF4: "carcubefused",
  CBA5: "carcubealign",
  GUA1: "guardian",
  GHO1: "ghost",
  STR1: "starlight",
  HPR1: "humanpresence",
  RBW1: "starspirit",
};

const BubbleImportFunction = (props) => {
  // If the data is an object, extract the code string. Otherwise, use the string directly.
  //   const rawCode =
  //     typeof code === "string" ? code : code?.kitCode || code?.imageBubbles?.[0];

  // Look up the full name, fallback to the raw code if it's missing from the dictionary

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        background: "#ffffff", // Clean white background
        border: "1px solid #00008b", // Dark blue trim
        borderRadius: "20px",
        padding: "4px 12px 4px 6px",
        margin: "0", // Margin removed because parent gap handles it
        color: "#00008b", // Dark blue text
        fontSize: "12px",
        fontFamily: "monospace",
        fontWeight: "bold",
        whiteSpace: "nowrap", // Crucial: Keeps the badge from breaking in half
        boxShadow: "0 2px 4px rgba(0, 0, 139, 0.1)",
        cursor: "default",
      }}
    >
      {/* The Lightning Symbol in a Little Circle */}
      <span
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#00008b", // Dark blue circle background
          color: "#ffffff", // White lightning bolt
          borderRadius: "50%",
          width: "20px",
          height: "20px",
          marginRight: "8px",
          fontSize: "12px",
        }}
      >
        ⚡
      </span>
      {props.showBubbles}
      {/* {props.showCode} */}
    </div>
  );
};

export default BubbleImportFunction;
